import {Component, Input} from '@angular/core';
import {FileUploadAction} from '@shared-models/common.enums';
import {FileUploadModel, IFileInfo} from '@ui-app/models/common.models';
import {BaseModal} from '../base-modal';

@Component({
    selector: 'ui-upload-photo-modal',
    templateUrl: './upload-photo-modal.component.html',
    styleUrls: ['./upload-photo-modal.component.less']
})
export class UploadPhotoModalComponent extends BaseModal {

    isDeleteRequestActive = false;
    upload: FileUploadModel = {
        data: [],
        action: FileUploadAction.Cancel
    };

    @Input() uploadConfig: Record<string, string | number>;
    @Input() newFileName: string;
    @Input() isVisitorRequest = false;
    @Input() isExtension = false;
    @Input() isAttachment = false;

    constructor() {
        super();
    }

    uploaded(files: IFileInfo[]): void {
        this.upload.data = files;
    }

    save(): void {
        this.upload.action = FileUploadAction.Upload;
        this.action(this.upload);
    }

    cancel(): void {
        this.upload.action = this.upload.data.length ? FileUploadAction.Delete : FileUploadAction.Cancel;
        this.action(this.upload);
    }
}
